import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Home from './Home';


function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
